var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg404(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 923,
    height: 397,
    viewBox: "0 0 923 397",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M168.72 265.9V302.24C168.72 313.893 169.64 322.327 171.48 327.54C173.32 332.753 176.694 336.28 181.6 338.12C186.814 339.96 194.94 341.187 205.98 341.8V351C193.1 350.08 173.474 349.62 147.1 349.62C119.194 349.62 97.1137 350.08 80.8603 351V341.8C94.6603 341.187 104.627 339.96 110.76 338.12C116.894 336.28 121.187 332.753 123.64 327.54C126.094 322.327 127.32 313.893 127.32 302.24V265.9H0.820312V256.7L161.36 18.88H168.72V235.08H226.68V265.9H168.72ZM127.32 235.08V83.28L25.6603 235.08H127.32Z",
    fill: "#061D38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M864.72 263.9V300.24C864.72 311.893 865.64 320.327 867.48 325.54C869.32 330.753 872.694 334.28 877.6 336.12C882.814 337.96 890.94 339.187 901.98 339.8V349C889.1 348.08 869.474 347.62 843.1 347.62C815.194 347.62 793.114 348.08 776.86 349V339.8C790.66 339.187 800.627 337.96 806.76 336.12C812.894 334.28 817.187 330.753 819.64 325.54C822.094 320.327 823.32 311.893 823.32 300.24V263.9H696.82V254.7L857.36 16.88H864.72V233.08H922.68V263.9H864.72ZM823.32 233.08V81.28L721.66 233.08H823.32Z",
    fill: "#061D38"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M464.5 252.023C474.933 252.023 483.391 243.566 483.391 233.133C483.391 222.7 474.933 214.242 464.5 214.242C454.067 214.242 445.61 222.7 445.61 233.133C445.61 243.566 454.067 252.023 464.5 252.023Z",
    fill: "#E21E25"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M464.5 289.805C355.13 289.805 266.149 248.847 266.149 198.5C266.149 148.153 355.13 107.195 464.5 107.195C573.871 107.195 662.852 148.153 662.852 198.5C662.852 248.847 573.871 289.805 464.5 289.805ZM464.5 113.492C358.599 113.492 272.446 151.626 272.446 198.5C272.446 245.374 358.599 283.508 464.5 283.508C570.401 283.508 656.555 245.374 656.555 198.5C656.555 151.626 570.401 113.492 464.5 113.492Z",
    fill: "url(#paint0_linear_674_20596)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M464.5 396.852C414.157 396.852 373.196 307.87 373.196 198.5C373.196 89.1296 414.157 0.148438 464.5 0.148438C514.844 0.148438 555.805 89.1296 555.805 198.5C555.805 307.87 514.844 396.852 464.5 396.852ZM464.5 6.44531C417.626 6.44531 379.492 92.5992 379.492 198.5C379.492 304.401 417.626 390.555 464.5 390.555C511.374 390.555 549.508 304.401 549.508 198.5C549.508 92.5992 511.374 6.44531 464.5 6.44531Z",
    fill: "url(#paint1_linear_674_20596)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M563.44 353.035C517.81 353.035 454.517 320.093 399.28 263.673C323.368 186.127 289.457 93.7735 323.686 57.7995C331.973 49.0909 344.97 44.4029 361.276 44.2329C361.594 44.2297 361.918 44.2266 362.239 44.2266C409.617 44.2266 476.751 79.9047 529.704 133.312C583.936 188.003 620.54 258.865 618.723 305.638C618.135 320.744 613.547 332.11 605.088 339.411C594.392 348.646 580.089 353.035 563.44 353.035ZM362.17 50.5234C361.893 50.5234 361.616 50.5234 361.342 50.5266C346.777 50.6746 335.333 54.6888 328.249 62.138C296.868 95.1179 331.46 185.39 403.78 259.265C475.63 332.658 564.085 366.475 600.972 334.648C608.06 328.534 611.913 318.692 612.43 305.396C614.183 260.235 578.326 191.293 525.234 137.745C465.388 77.3922 400.426 50.5234 362.17 50.5234Z",
    fill: "url(#paint2_linear_674_20596)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M365.646 353.035C348.99 353.035 334.697 348.649 323.995 339.415C315.532 332.113 310.945 320.751 310.359 305.641C308.546 258.868 345.149 188.006 399.378 133.315C452.694 79.5426 520.524 43.7952 567.807 44.2329C584.116 44.3997 597.113 49.0909 605.396 57.7995C639.626 93.7735 605.717 186.13 529.802 263.673C474.572 320.09 411.276 353.035 365.646 353.035ZM328.11 334.648C364.988 366.475 453.452 332.661 525.303 259.265C597.626 185.39 632.214 95.1179 600.834 62.138C593.75 54.692 582.305 50.6777 567.741 50.5266C567.47 50.5266 567.19 50.5234 566.913 50.5234C528.656 50.5234 463.697 77.3859 403.849 137.748C350.757 191.293 314.899 260.235 316.653 305.399C317.169 318.692 321.023 328.534 328.11 334.648Z",
    fill: "url(#paint3_linear_674_20596)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M436.164 201.648C446.597 201.648 455.055 193.191 455.055 182.758C455.055 172.325 446.597 163.867 436.164 163.867C425.731 163.867 417.274 172.325 417.274 182.758C417.274 193.191 425.731 201.648 436.164 201.648Z",
    fill: "#E21E25"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M436.164 236.281C446.597 236.281 455.055 227.824 455.055 217.391C455.055 206.958 446.597 198.5 436.164 198.5C425.731 198.5 417.274 206.958 417.274 217.391C417.274 227.824 425.731 236.281 436.164 236.281Z",
    fill: "url(#paint4_linear_674_20596)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M492.836 201.648C503.269 201.648 511.727 193.191 511.727 182.758C511.727 172.325 503.269 163.867 492.836 163.867C482.403 163.867 473.946 172.325 473.946 182.758C473.946 193.191 482.403 201.648 492.836 201.648Z",
    fill: "#E21E25"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M492.836 236.281C503.269 236.281 511.727 227.824 511.727 217.391C511.727 206.958 503.269 198.5 492.836 198.5C482.403 198.5 473.946 206.958 473.946 217.391C473.946 227.824 482.403 236.281 492.836 236.281Z",
    fill: "url(#paint5_linear_674_20596)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M464.5 182.758C474.933 182.758 483.391 174.3 483.391 163.867C483.391 153.434 474.933 144.977 464.5 144.977C454.067 144.977 445.61 153.434 445.61 163.867C445.61 174.3 454.067 182.758 464.5 182.758Z",
    fill: "url(#paint6_linear_674_20596)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M464.5 220.539C476.672 220.539 486.539 210.672 486.539 198.5C486.539 186.328 476.672 176.461 464.5 176.461C452.328 176.461 442.461 186.328 442.461 198.5C442.461 210.672 452.328 220.539 464.5 220.539Z",
    fill: "url(#paint7_linear_674_20596)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M464.5 207.945C462.759 207.945 461.352 206.535 461.352 204.797V192.203C461.352 190.465 462.759 189.055 464.5 189.055C466.241 189.055 467.649 190.465 467.649 192.203V204.797C467.649 206.535 466.241 207.945 464.5 207.945Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M470.797 201.648H458.203C456.462 201.648 455.055 200.238 455.055 198.5C455.055 196.762 456.462 195.352 458.203 195.352H470.797C472.538 195.352 473.946 196.762 473.946 198.5C473.946 200.238 472.538 201.648 470.797 201.648Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M325.969 362.219C339.88 362.219 351.157 350.942 351.157 337.031C351.157 323.121 339.88 311.844 325.969 311.844C312.058 311.844 300.782 323.121 300.782 337.031C300.782 350.942 312.058 362.219 325.969 362.219Z",
    fill: "#061D38"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M335.414 340.18H316.524C314.783 340.18 313.375 338.769 313.375 337.031C313.375 335.293 314.783 333.883 316.524 333.883H335.414C337.155 333.883 338.563 335.293 338.563 337.031C338.563 338.769 337.155 340.18 335.414 340.18Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M603.032 85.1562C616.942 85.1562 628.219 73.8794 628.219 59.9688C628.219 46.0581 616.942 34.7812 603.032 34.7812C589.121 34.7812 577.844 46.0581 577.844 59.9688C577.844 73.8794 589.121 85.1562 603.032 85.1562Z",
    fill: "#061D38"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M612.477 63.1172H593.586C591.845 63.1172 590.438 61.7067 590.438 59.9688C590.438 58.2308 591.845 56.8203 593.586 56.8203H612.477C614.218 56.8203 615.625 58.2308 615.625 59.9688C615.625 61.7067 614.218 63.1172 612.477 63.1172Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M313.375 160.719C327.286 160.719 338.563 149.442 338.563 135.531C338.563 121.621 327.286 110.344 313.375 110.344C299.465 110.344 288.188 121.621 288.188 135.531C288.188 149.442 299.465 160.719 313.375 160.719Z",
    fill: "#061D38"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M322.821 138.68H303.93C302.189 138.68 300.782 137.269 300.782 135.531C300.782 133.793 302.189 132.383 303.93 132.383H322.821C324.562 132.383 325.969 133.793 325.969 135.531C325.969 137.269 324.562 138.68 322.821 138.68Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M609.328 283.508C623.239 283.508 634.516 272.231 634.516 258.32C634.516 244.41 623.239 233.133 609.328 233.133C595.418 233.133 584.141 244.41 584.141 258.32C584.141 272.231 595.418 283.508 609.328 283.508Z",
    fill: "#061D38"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M618.774 261.469H599.883C598.142 261.469 596.735 260.058 596.735 258.32C596.735 256.582 598.142 255.172 599.883 255.172H618.774C620.515 255.172 621.922 256.582 621.922 258.32C621.922 260.058 620.515 261.469 618.774 261.469Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_674_20596",
    x1: 1229.93,
    y1: 515.329,
    x2: 1067.91,
    y2: 438.864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDEDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CED0D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_674_20596",
    x1: 2130.56,
    y1: 344.342,
    x2: 2058.35,
    y2: 183.526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDEDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CED0D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_674_20596",
    x1: 1448.79,
    y1: 386.417,
    x2: 1324.71,
    y2: 259.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDEDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CED0D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_674_20596",
    x1: 1450.07,
    y1: 385.312,
    x2: 1325.99,
    y2: 257.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDEDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CED0D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_674_20596",
    x1: 3574.49,
    y1: 187.425,
    x2: 2800.13,
    y2: 202.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0A700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9973,
    stopColor: "#FFAF54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_674_20596",
    x1: 2191.85,
    y1: 192.351,
    x2: 1417.41,
    y2: 207.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0A700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9973,
    stopColor: "#FFAF54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_674_20596",
    x1: 2872.34,
    y1: 189.938,
    x2: 2097.98,
    y2: 204.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0A700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9973,
    stopColor: "#FFAF54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_674_20596",
    x1: 1881.48,
    y1: 57.9254,
    x2: 1373.75,
    y2: 329.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE684"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC76A"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.bb17ae82050d4950e3f2616b1620f4f7.svg";
export { ForwardRef as ReactComponent };